import clsx from "clsx";
import { useFormContext, Controller, Path } from "react-hook-form";
import { MAX_FILE_SIZE } from "@/features/jobs/configs/constants";
import Loading from "@/shared/components/Loading";
import { Button } from "@/shared/ui/Button";
import { Input } from "@/shared/ui/Input";

type FormData = { file: File };

type FileUploaderButtonProps<T extends FormData> = { onSubmit: (data: T) => void };

const FileUploaderButton = <T extends FormData>({ onSubmit }: FileUploaderButtonProps<T>) => {
  const {
    control,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useFormContext<T>();

  return (
    <form>
      <Button
        asChild
        variant="action"
        className={clsx("relative mt-2 min-w-1/2", isSubmitting && "cursor-not-allowed opacity-50")}
        disabled={isSubmitting}
      >
        <label htmlFor="file">
          {isSubmitting && (
            <Loading
              state={{
                loading: true,
                size: 4,
                borderSize: 2,
              }}
              className="absolute left-3 mr-2"
            />
          )}
          Importez votre fichier
        </label>
      </Button>
      {errors.file && <p className="text-red-500 text-sm mt-2 ml-5">{errors.file.message?.toString()}</p>}

      <p className="text-sm text-gray-500 mt-2">
        Taille maximale :
        {MAX_FILE_SIZE / (1024 * 1024)}
        Mo
      </p>
      <Controller<T>
        name={"file" as Path<T>}
        control={control}
        render={({ field }) => (
          <Input
            id="file"
            type="file"
            accept=".xlsx,.xls"
            onChange={(event) => {
              const file = event.target.files?.[0];
              field.onChange(file);
              handleSubmit(onSubmit)();
            }}
            disabled={isSubmitting}
            hidden
          />
        )}
      />
    </form>
  );
};

export default FileUploaderButton;
